import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";

export const scrollAreaTheme = themed({
    keyline: {
        start: {
            boxShadow: {
                vertical: {
                    rest: {
                        "lodestar-light": `0 2px 0 0 ${color("color--border--neutral--default")}`,
                        "ursa-light": `0 1px 0 0 var(--sds--keyline--color, ${color("color--border--slate--weaker")})`,
                    },
                    scrolling: {
                        "lodestar-light": `0 2px 0 0 ${color("color--border--neutral--default")}`,
                        "ursa-light": color("elevation--low"),
                    },
                },
                horizontal: {
                    rest: {
                        "lodestar-light": `2px 0 0 0 ${color("color--border--neutral--default")}`,
                        "ursa-light": `1px 0 0 0 var(--sds--keyline--color, ${color("color--border--slate--weaker")})`,
                    },
                    scrolling: {
                        "lodestar-light": `2px 0 0 0 ${color("color--border--neutral--default")}`,
                        "ursa-light": "2px 0px 4px rgba(57, 61, 76, 0.16), 6px 0px 12px rgba(65, 80, 139, 0.12)",
                    },
                },
            },
        },
        end: {
            boxShadow: {
                vertical: {
                    rest: {
                        "lodestar-light": `0 -2px 0 0 ${color("color--border--neutral--default")}`,
                        "ursa-light": `0 -1px 0 0 var(--sds--keyline--color, ${color("color--border--slate--weaker")})`,
                    },
                    scrolling: {
                        "lodestar-light": `0 -2px 0 0 ${color("color--border--neutral--default")}`,
                        // Can't use this here since the y offset is negative.
                        // color("elevation--low")
                        "ursa-light": "0px -2px 4px rgba(57,61,76,0.16), 0px -6px 12px rgba(65,80,139,0.12)",
                    },
                },
                horizontal: {
                    rest: {
                        "lodestar-light": `-2px 0 0 0 ${color("color--border--neutral--default")}`,
                        "ursa-light": `-1px 0 0 0 var(--sds--keyline--color, ${color("color--border--slate--weaker")})`,
                    },
                    scrolling: {
                        "lodestar-light": `-2px 0 0 0 ${color("color--border--neutral--default")}`,
                        // Can't use this here since the y offset is negative.
                        // color("elevation--low")
                        "ursa-light": "-2px 0 4px rgba(57,61,76,0.16), 0px -6px 12px rgba(65,80,139,0.12)",
                    },
                },
            },
        },
    },
});
